import { create } from "zustand"

export type Currencies = {
  [key: string]: number | null
}

type CurrenciesBcaState = {
  sell: Currencies | null
  buy: Currencies | null
  xRates: Currencies | null
}

type State = {
  currencies: Currencies | null
  bca: CurrenciesBcaState
  date: string
  selectedCurrency: string
  isLoading: boolean
}

type Actions = {
  setCurrencies: (newCurrencies: Currencies) => void
  setSelectedCurrency: (value: string) => void
  setDate: (value: string) => void
  setIsLoading: (value: boolean) => void
  setBcaCurrencies: (newBcaCurrencies: CurrenciesBcaState) => void
}

const initialState: State = {
  currencies: null,
  bca: {
    sell: null,
    buy: null,
    xRates: null
  },
  date: "",
  selectedCurrency: "USD",
  isLoading: true
}

export const useCurrencyStore = create<State & Actions>(set => ({
  ...initialState,
  setCurrencies: (newCurrencies: Currencies) =>
    set(state => ({
      ...state,
      currencies: {
        ...newCurrencies
      }
    })),
  setSelectedCurrency: (selectedCurrency: string) =>
    set(state => ({
      ...state,
      selectedCurrency
    })),
  setDate: (value: string) =>
    set(state => ({
      ...state,
      date: value
    })),
  setIsLoading: (value: boolean) =>
    set(state => ({
      ...state,
      isLoading: value
    })),
  setBcaCurrencies: (newBcaCurrencies: CurrenciesBcaState) =>
    set(state => ({
      ...state,
      bca: { ...newBcaCurrencies }
    }))
}))
